import React, { useState } from "react";
import { SaveCandidate } from "../services/apiService";
import { getUserFromToken } from "../services/authService";
import { toast } from "react-hot-toast";

const QuickAddCandidateModal = ({ isOpen, onClose, onSubmit, request_id, companyCode }) => {
  const [candidate, setCandidate] = useState({
    full_name: "",
    status: "Created",
    highest_degree: "",
    descriptions: "",
    company_name: "",
    experience_years: "",
    last_job_title: "",
    last_salary: "",
    expected_salary: "",
    request_id,
    companyCode,
    Documents: {
      FileName: "",
      FileBase64: "",
      Size: 0,
      MimeType: "",
      reference_id: "0",
      process_type: "",
      uploaded_by: "",
      uploaded_at: "",
      IsActive: true,
    },
  });

  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [isSubmitConfirmed, setIsSubmitConfirmed] = useState(false);
  const [errors, setErrors] = useState({});

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const userName = getUserFromToken();
    const validTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];

    if (!file) {
      toast.error("No file selected.");
      return;
    }
    if (!validTypes.includes(file.type)) {
      toast.error("Invalid file type. Only PDF or image files are allowed.");
      e.target.value = null;
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast.error("File size exceeds 5MB. Please upload a smaller file.");
      e.target.value = null;
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      setCandidate((prev) => ({
        ...prev,
        Documents: {
          ...prev.Documents,
          FileName: file.name,
          FileBase64: reader.result.split(",")[1],
          Size: file.size,
          MimeType: file.type,
          reference_id: "0",
          process_type: "Resume",
          uploaded_by: userName,
          uploaded_at: new Date().toISOString(),
          IsActive: true,
        },
      }));
      setErrors({});
    };
    reader.readAsDataURL(file);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCandidate((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const cleanNumericFields = (candidate) => {
    const fields = ["experience_years", "last_salary", "expected_salary"];
    const cleaned = { ...candidate };
    fields.forEach((field) => {
      const value = cleaned[field];
      cleaned[field] = value === "" || value == null || isNaN(value) ? null : Number(value);
    });
    return cleaned;
  };

  const handleSubmit = async () => {
    const validationErrors = {};
    if (!candidate.full_name?.trim()) validationErrors.full_name = "Full name is required";
    if (!candidate.experience_years || isNaN(candidate.experience_years) || candidate.experience_years < 0)
      validationErrors.experience_years = "Please enter a valid years of experience";
    if (!candidate.highest_degree?.trim()) validationErrors.highest_degree = "Education (highest degree) is required";
    if (!candidate.company_name?.trim()) validationErrors.company_name = "Current employer is required";
    if (!candidate.last_job_title?.trim()) validationErrors.last_job_title = "Current position is required";
    if (!candidate.last_salary || isNaN(candidate.last_salary) || candidate.last_salary < 0)
      validationErrors.last_salary = "Please enter a valid current salary";
    if (!candidate.expected_salary || isNaN(candidate.expected_salary) || candidate.expected_salary < 0)
      validationErrors.expected_salary = "Please enter a valid expected salary";
    if (!candidate.descriptions?.trim()) validationErrors.descriptions = "Recruiter notes are required";
    if (!candidate.Documents.FileBase64) validationErrors.resume = "Please upload a resume";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      Object.values(validationErrors).forEach((msg) => toast.error(msg));
      return;
    }

    try {
      setErrors({});
      setIsSubmitConfirmed(true);

      const userName = getUserFromToken();
      const cleanedCandidate = cleanNumericFields({
        ...candidate,
        created_by: userName,
        Documents: { ...candidate.Documents, uploaded_by: userName },
      });

      const savedRequest = await SaveCandidate(cleanedCandidate);

      if ([400, 500].includes(Number(savedRequest.status))) {
        setIsSubmitConfirmed(false);
        toast.error("Failed to save the candidate.");
      } else if (Number(savedRequest.status) === 409) {
        setIsSubmitConfirmed(false);
        toast.error("The email is already associated with this request.");
      } else {
        toast.success("Candidate saved successfully!");
        onClose();
      }
    } catch (error) {
      setIsSubmitConfirmed(false);
      console.error(error);
      toast.error("Submission failed. Please try again.");
    }
  };

  if (!isOpen) return null;

  return (
 
  <div className="fixed inset-0 backdrop-blur-sm flex justify-center items-center  z-50  p-4" style={{ backgroundColor: 'rgba(18, 76, 114, 0.2)' }}>
    <div 
      className="relative bg-white rounded-2xl shadow-2xl flex flex-col w-full max-w-full sm:max-w-lg md:max-w-xl lg:max-w-2xl max-h-[90vh] overflow-y-auto"
      style={{ 
        borderColor: 'rgba(18, 76, 114, 0.1)', 
        borderWidth: '1px',
     
      }}
    >
      {/* Modal Header */}
      <div className="flex items-center justify-between p-6 border-b rounded-t-2xl" style={{ 
        borderColor: 'rgba(18, 76, 114, 0.1)',
        background: 'linear-gradient(to right, rgba(18, 76, 114, 0.05), transparent)'
      }}>
        <h2 className="text-xl font-semibold" style={{ color: 'rgb(18, 76, 114)' }}>
          Add Candidate (Quick)
        </h2>
        <button 
          onClick={onClose}
          className="transition-all rounded-full p-1.5"
          style={{ color: 'rgba(18, 76, 114, 0.6)' }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgb(18, 76, 114)';
            e.currentTarget.style.color = 'white';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = 'rgba(18, 76, 114, 0.6)';
          }}
          aria-label="Close"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Modal Body */}
      <div className="flex-1 overflow-hidden">
        <div className="h-full overflow-y-auto p-6">
          {/* Candidate Fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {/* Full Name */}
           <div className="space-y-2 md:col-span-2 lg:col-span-3">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="full_name"
                  value={candidate.full_name || ""}
                  onChange={handleChange}
                  placeholder="Full Name"
                  className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700"
                  style={{ 
                    borderColor: errors.full_name ? 'rgb(220, 38, 38)' : 'rgba(18, 76, 114, 0.3)',
                    backgroundColor: 'white'
                  }}
                  onFocus={(e) => {
                    e.target.style.boxShadow = errors.full_name 
                      ? '0 0 0 2px rgba(220, 38, 38, 0.2)' 
                      : '0 0 0 2px rgba(18, 76, 114, 0.2)';
                    e.target.style.borderColor = errors.full_name 
                      ? 'rgb(220, 38, 38)' 
                      : 'rgb(18, 76, 114)';
                  }}
                  onBlur={(e) => {
                    e.target.style.boxShadow = 'none';
                    e.target.style.borderColor = errors.full_name 
                      ? 'rgb(220, 38, 38)' 
                      : 'rgba(18, 76, 114, 0.3)';
                  }}
                />
                {errors.full_name && (
                  <div className="text-red-500 text-xs flex items-center">
                    <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    {errors.full_name}
                  </div>
                )}
              </div>

            {/* Experience */}
           <div className="space-y-2">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Years of Experience
                </label>
                <input
                  type="number"
                  name="experience_years"
                  value={candidate.experience_years || ""}
                  onChange={handleChange}
                  placeholder="Years of Experience"
                  className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700"
                  style={{ 
                    borderColor: errors.experience_years ? 'rgb(220, 38, 38)' : 'rgba(18, 76, 114, 0.3)',
                    backgroundColor: 'white'
                  }}
                  onFocus={(e) => {
                    e.target.style.boxShadow = errors.experience_years 
                      ? '0 0 0 2px rgba(220, 38, 38, 0.2)' 
                      : '0 0 0 2px rgba(18, 76, 114, 0.2)';
                    e.target.style.borderColor = errors.experience_years 
                      ? 'rgb(220, 38, 38)' 
                      : 'rgb(18, 76, 114)';
                  }}
                  onBlur={(e) => {
                    e.target.style.boxShadow = 'none';
                    e.target.style.borderColor = errors.experience_years 
                      ? 'rgb(220, 38, 38)' 
                      : 'rgba(18, 76, 114, 0.3)';
                  }}
                />
                {errors.experience_years && (
                  <div className="text-red-500 text-xs flex items-center">
                    <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    {errors.experience_years}
                  </div>
                )}
              </div>

            {/* Education */}
          <div className="space-y-2">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Education <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="highest_degree"
                  value={candidate.highest_degree || ""}
                  onChange={handleChange}
                  placeholder="Highest Degree"
                  className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700"
                  style={{ 
                    borderColor: errors.highest_degree ? 'rgb(220, 38, 38)' : 'rgba(18, 76, 114, 0.3)',
                    backgroundColor: 'white'
                  }}
                  onFocus={(e) => {
                    e.target.style.boxShadow = errors.highest_degree 
                      ? '0 0 0 2px rgba(220, 38, 38, 0.2)' 
                      : '0 0 0 2px rgba(18, 76, 114, 0.2)';
                    e.target.style.borderColor = errors.highest_degree 
                      ? 'rgb(220, 38, 38)' 
                      : 'rgb(18, 76, 114)';
                  }}
                  onBlur={(e) => {
                    e.target.style.boxShadow = 'none';
                    e.target.style.borderColor = errors.highest_degree 
                      ? 'rgb(220, 38, 38)' 
                      : 'rgba(18, 76, 114, 0.3)';
                  }}
                />
                {errors.highest_degree && (
                  <div className="text-red-500 text-xs flex items-center">
                    <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    {errors.highest_degree}
                  </div>
                )}
              </div>

            {/* Current Employer */}
            <div className="space-y-2">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Current Employer <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="company_name"
                  value={candidate.company_name || ""}
                  onChange={handleChange}
                  placeholder="Current Employer"
                  className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700"
                  style={{ 
                    borderColor: errors.company_name ? 'rgb(220, 38, 38)' : 'rgba(18, 76, 114, 0.3)',
                    backgroundColor: 'white'
                  }}
                  onFocus={(e) => {
                    e.target.style.boxShadow = errors.company_name 
                      ? '0 0 0 2px rgba(220, 38, 38, 0.2)' 
                      : '0 0 0 2px rgba(18, 76, 114, 0.2)';
                    e.target.style.borderColor = errors.company_name 
                      ? 'rgb(220, 38, 38)' 
                      : 'rgb(18, 76, 114)';
                  }}
                  onBlur={(e) => {
                    e.target.style.boxShadow = 'none';
                    e.target.style.borderColor = errors.company_name 
                      ? 'rgb(220, 38, 38)' 
                      : 'rgba(18, 76, 114, 0.3)';
                  }}
                />
                {errors.company_name && (
                  <div className="text-red-500 text-xs flex items-center">
                    <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    {errors.company_name}
                  </div>
                )}
              </div>


            {/* Current Position */}
        <div className="space-y-2">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Current Position <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="last_job_title"
                  value={candidate.last_job_title || ""}
                  onChange={handleChange}
                  placeholder="Current Position"
                  className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700"
                  style={{ 
                    borderColor: errors.last_job_title ? 'rgb(220, 38, 38)' : 'rgba(18, 76, 114, 0.3)',
                    backgroundColor: 'white'
                  }}
                  onFocus={(e) => {
                    e.target.style.boxShadow = errors.last_job_title 
                      ? '0 0 0 2px rgba(220, 38, 38, 0.2)' 
                      : '0 0 0 2px rgba(18, 76, 114, 0.2)';
                    e.target.style.borderColor = errors.last_job_title 
                      ? 'rgb(220, 38, 38)' 
                      : 'rgb(18, 76, 114)';
                  }}
                  onBlur={(e) => {
                    e.target.style.boxShadow = 'none';
                    e.target.style.borderColor = errors.last_job_title 
                      ? 'rgb(220, 38, 38)' 
                      : 'rgba(18, 76, 114, 0.3)';
                  }}
                />
                {errors.last_job_title && (
                  <div className="text-red-500 text-xs flex items-center">
                    <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    {errors.last_job_title}
                  </div>
                )}
              </div>
            {/* Current Salary */}
            <div className="space-y-2">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Current Salary
                </label>
                <div className="relative">
                  <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-xs font-medium">SAR</span>
                  <input
                    type="number"
                    name="last_salary"
                    value={candidate.last_salary || ""}
                    onChange={handleChange}
                    placeholder="Current Salary"
                    className="w-full pl-12 pr-3 py-2.5 border rounded-lg outline-none transition text-gray-700"
                    style={{ 
                      borderColor: errors.last_salary ? 'rgb(220, 38, 38)' : 'rgba(18, 76, 114, 0.3)',
                      backgroundColor: 'white'
                    }}
                    onFocus={(e) => {
                      e.target.style.boxShadow = errors.last_salary 
                        ? '0 0 0 2px rgba(220, 38, 38, 0.2)' 
                        : '0 0 0 2px rgba(18, 76, 114, 0.2)';
                      e.target.style.borderColor = errors.last_salary 
                        ? 'rgb(220, 38, 38)' 
                        : 'rgb(18, 76, 114)';
                    }}
                    onBlur={(e) => {
                      e.target.style.boxShadow = 'none';
                      e.target.style.borderColor = errors.last_salary 
                        ? 'rgb(220, 38, 38)' 
                        : 'rgba(18, 76, 114, 0.3)';
                    }}
                  />
                </div>
                {errors.last_salary && (
                  <div className="text-red-500 text-xs flex items-center">
                    <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    {errors.last_salary}
                  </div>
                )}
              </div>

            {/* Expected Salary */}
            <div className="space-y-2">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Expected Salary
                </label>
                <div className="relative">
                  <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-xs font-medium">SAR</span>
                  <input
                    type="number"
                    name="expected_salary"
                    value={candidate.expected_salary || ""}
                    onChange={handleChange}
                    placeholder="Expected Salary"
                    className="w-full pl-12 pr-3 py-2.5 border rounded-lg outline-none transition text-gray-700"
                    style={{ 
                      borderColor: errors.expected_salary ? 'rgb(220, 38, 38)' : 'rgba(18, 76, 114, 0.3)',
                      backgroundColor: 'white'
                    }}
                    onFocus={(e) => {
                      e.target.style.boxShadow = errors.expected_salary 
                        ? '0 0 0 2px rgba(220, 38, 38, 0.2)' 
                        : '0 0 0 2px rgba(18, 76, 114, 0.2)';
                      e.target.style.borderColor = errors.expected_salary 
                        ? 'rgb(220, 38, 38)' 
                        : 'rgb(18, 76, 114)';
                    }}
                    onBlur={(e) => {
                      e.target.style.boxShadow = 'none';
                      e.target.style.borderColor = errors.expected_salary 
                        ? 'rgb(220, 38, 38)' 
                        : 'rgba(18, 76, 114, 0.3)';
                    }}
                  />
                </div>
                {errors.expected_salary && (
                  <div className="text-red-500 text-xs flex items-center">
                    <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    {errors.expected_salary}
                  </div>
                )}
              </div>

            {/* Recruiter Notes */}
              <div className="md:col-span-2 lg:col-span-3 space-y-2">
                <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Recruiter Notes <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="descriptions"
                  value={candidate.descriptions || ""}
                  onChange={handleChange}
                  placeholder="Add notes about the candidate..."
                  className="w-full px-3 py-2.5 border rounded-lg outline-none transition text-gray-700 resize-vertical"
                  style={{ 
                    borderColor: errors.descriptions ? 'rgb(220, 38, 38)' : 'rgba(18, 76, 114, 0.3)',
                    backgroundColor: 'white',
                    minHeight: '100px'
                  }}
                  onFocus={(e) => {
                    e.target.style.boxShadow = errors.descriptions 
                      ? '0 0 0 2px rgba(220, 38, 38, 0.2)' 
                      : '0 0 0 2px rgba(18, 76, 114, 0.2)';
                    e.target.style.borderColor = errors.descriptions 
                      ? 'rgb(220, 38, 38)' 
                      : 'rgb(18, 76, 114)';
                  }}
                  onBlur={(e) => {
                    e.target.style.boxShadow = 'none';
                    e.target.style.borderColor = errors.descriptions 
                      ? 'rgb(220, 38, 38)' 
                      : 'rgba(18, 76, 114, 0.3)';
                  }}
                />
                {errors.descriptions && (
                  <div className="text-red-500 text-xs flex items-center">
                    <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    {errors.descriptions}
                  </div>
                )}
              </div>
            </div>

          

          {/* Resume Upload */}
          <div className="mt-8 border-t pt-6" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>
            <div className="space-y-2">
              <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                Upload Resume (PDF/Image) <span className="text-red-500">*</span>
              </label>
              <div className="flex items-center gap-4">
                <div className="relative flex-1">
                  <input
                    type="file"
                    id="resume-upload"
                    accept="application/pdf,image/png,image/jpeg,image/jpg"
                    onChange={handleFileChange}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                  />
                  <div 
                    className="px-4 py-3 border rounded-lg transition-all"
                    style={{ 
                      borderColor: errors.resume ? 'rgb(220, 38, 38)' : 'rgba(18, 76, 114, 0.3)',
                      backgroundColor: 'white'
                    }}
                  >
                    <div className="flex items-center gap-3">
                      <div className="p-2 rounded-lg" style={{ backgroundColor: 'rgba(18, 76, 114, 0.1)' }}>
                        <svg className="w-5 h-5" style={{ color: 'rgb(18, 76, 114)' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                        </svg>
                      </div>
                      <div className="flex-1">
                        <p className="text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                          {candidate.Documents?.FileName || 'Click to upload resume'}
                        </p>
                        <p className="text-xs text-gray-500">
                          {candidate.Documents?.FileName 
                            ? `(${(candidate.Documents.Size / 1024).toFixed(2)} KB)` 
                            : 'Supports: PDF, PNG, JPG (Max 5MB)'}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {candidate.Documents?.FileBase64 && (
                  <button
                    type="button"
                    onClick={() => setIsViewerOpen(true)}
                    className="px-4 py-2.5 border rounded-lg transition-all font-medium flex items-center gap-2"
                    style={{ 
                      color: 'rgb(18, 76, 114)',
                      borderColor: 'rgba(18, 76, 114, 0.3)',
                      backgroundColor: 'white'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'white';
                    }}
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                    View Resume
                  </button>
                )}
              </div>
              
              {errors.resume && (
                <div className="text-red-500 text-xs mt-1 flex items-center">
                  <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                  </svg>
                  {errors.resume}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal Footer */}
      <div className="flex flex-col sm:flex-row justify-end gap-3 p-6 border-t rounded-b-2xl" style={{ 
        borderColor: 'rgba(18, 76, 114, 0.1)',
        background: 'linear-gradient(to right, transparent, rgba(18, 76, 114, 0.05))'
      }}>
        <button
          onClick={onClose}
          className="px-5 py-2.5 bg-white border rounded-lg transition-all font-medium"
          style={{ 
            color: 'rgb(18, 76, 114)',
            borderColor: 'rgba(18, 76, 114, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'white';
          }}
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit}
          disabled={isSubmitConfirmed}
          className="px-5 py-2.5 text-white font-medium rounded-lg transition-all"
          style={{ 
            backgroundColor: isSubmitConfirmed ? 'rgba(18, 76, 114, 0.5)' : 'rgb(18, 76, 114)',
            cursor: isSubmitConfirmed ? 'not-allowed' : 'pointer',
            boxShadow: isSubmitConfirmed ? 'none' : '0 10px 15px -3px rgba(18, 76, 114, 0.2)'
          }}
          onMouseEnter={(e) => {
            if (!isSubmitConfirmed) {
              e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.9)';
            }
          }}
          onMouseLeave={(e) => {
            if (!isSubmitConfirmed) {
              e.currentTarget.style.backgroundColor = 'rgb(18, 76, 114)';
            }
          }}
        >
          {isSubmitConfirmed ? 'Submitting...' : 'Submit'}
        </button>
      </div>

      {/* Resume Preview Modal */}
      {isViewerOpen && candidate.Documents?.FileBase64 && (
        <div className="fixed inset-0 backdrop-blur-sm flex justify-center items-center z-[10000] p-4" style={{ backgroundColor: 'rgba(18, 76, 114, 0.3)' }}>
          <div 
            className="relative bg-white rounded-2xl shadow-2xl flex flex-col"
            style={{ 
              borderColor: 'rgba(18, 76, 114, 0.1)', 
              borderWidth: '1px',
              width: '95vw',
              maxWidth: '1000px',
              height: '90vh',
              maxHeight: '700px'
            }}
          >
            {/* Preview Header */}
            <div className="flex items-center justify-between p-6 border-b rounded-t-2xl" style={{ 
              borderColor: 'rgba(18, 76, 114, 0.1)',
              background: 'linear-gradient(to right, rgba(18, 76, 114, 0.05), transparent)'
            }}>
              <h3 className="text-lg font-semibold" style={{ color: 'rgb(18, 76, 114)' }}>
                Resume Preview
              </h3>
              <button 
                onClick={() => setIsViewerOpen(false)}
                className="transition-all rounded-full p-1.5"
                style={{ color: 'rgba(18, 76, 114, 0.6)' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgb(18, 76, 114)';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = 'rgba(18, 76, 114, 0.6)';
                }}
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Preview Content */}
            <div className="flex-1 overflow-hidden">
              <iframe
                title="Resume Preview"
                className="w-full h-full border-0"
                src={`data:application/pdf;base64,${candidate.Documents.FileBase64}`}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
 
  );
};

export default QuickAddCandidateModal;